// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/components/NiogemsIdentitySection.jsx
import PropTypes from "prop-types";
import { formatMessage, formatMessagePretty } from "../utils/niogemsPayload";
import ParsedPayloadList from "./ParsedPayloadList";

export default function NiogemsIdentitySection({
  niogemsAuth,
  niogemsLoading,
  portalUserEmail,
  isApproved,
  isDenied,
  parsedPayload,
  onCheckStatus,
}) {
  return (
    <div className="sso-auth-flow__section sso-auth-flow__section--niogems">
      <h3>
        Step 2: NIOGEMS Identity (from NIOGEMS USER API(NiogemsSystem/V1/Authenticate))
      </h3>
      <p>
        Click the button below to verify your NIOGEMS User status using your
        BOGS-authenticated email address.
      </p>

      <button
        type="button"
        className="sso-auth-flow__check-status-button"
        onClick={onCheckStatus}
        disabled={niogemsLoading || !portalUserEmail}
      >
        {niogemsLoading ? "Verifying Status..." : "Check Your Status"}
      </button>

      <div className="sso-auth-flow__result-wrapper">
        {!niogemsAuth && !niogemsLoading && (
          <p className="sso-auth-flow__no-handshake">
            <em>No handshake requested yet. Ready when you are.</em>
          </p>
        )}

        {niogemsAuth && (
          <div
            className={`sso-auth-flow__result-box ${
              isApproved
                ? "sso-auth-flow__result-box--approved"
                : "sso-auth-flow__result-box--denied"
            }`}
          >
            {isDenied && (
              <div className="sso-auth-flow__denied">
                <p>
                  ❌ <strong>Access Denied or Intercepted.</strong>
                </p>
                <p>
                  <strong>Returned Status Category:</strong>{" "}
                  <code>{niogemsAuth.status}</code>
                </p>
                <p>
                  <strong>Server Message:</strong> {formatMessage(niogemsAuth.message)}
                </p>
              </div>
            )}

            {isApproved && (
              <div>
                <p className="sso-auth-flow__approved-title">
                  ✔ <strong>Success! Active Dev Bypass Intercepted.</strong>
                </p>
                <p className="sso-auth-flow__status-rule">
                  <strong>Status Rule:</strong> <code>{niogemsAuth.status}</code>
                </p>

                <ParsedPayloadList data={parsedPayload} />

                <div className="sso-auth-flow__raw-payload">
                  <p className="sso-auth-flow__raw-payload-label">
                    Raw Stream Payload Message:
                  </p>
                  <pre className="sso-auth-flow__raw-payload-pre">
                    {formatMessagePretty(niogemsAuth.message)}
                  </pre>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

NiogemsIdentitySection.propTypes = {
  niogemsAuth: PropTypes.shape({
    action: PropTypes.string,
    status: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  niogemsLoading: PropTypes.bool,
  portalUserEmail: PropTypes.string,
  isApproved: PropTypes.bool.isRequired,
  isDenied: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- dynamic API payload shape
  parsedPayload: PropTypes.object,
  onCheckStatus: PropTypes.func.isRequired,
};

NiogemsIdentitySection.defaultProps = {
  niogemsAuth: null,
  niogemsLoading: false,
  portalUserEmail: null,
  parsedPayload: null,
};